/* eslint-disable @typescript-eslint/ban-ts-comment */
import {AxiosResponse} from "axios";
import {Filter} from "@mm-products/java-multima-framework";
import {taxGuruAxios} from "../axios";
import {documentItemsUrls} from "../url";
import {TaxDocumentItemResult} from "../models/TaxDocumentItemResult";
import {TaxDocumentItemDto} from "../models/TaxDocumentItemDto";
import {TaxDocumentItemRequest} from "../models/TaxDocumentItemRequest";
import {DocumentItemSplitByTaxCentreFormDialogProps} from "../../../modules/document/items/DocumentItemSplitByCentreFormDialog";

export const listDocumentItems = (filter: Filter, signal?: AbortSignal, toastId?: string): Promise<AxiosResponse<TaxDocumentItemResult>> => {
    return taxGuruAxios.post(documentItemsUrls.filter, filter, {
        // @ts-ignore
        toastId,
        signal,
    });
};

export const listDocumentItemsForDocument = (
    documentId: string,
    filter?: Filter,
    signal?: AbortSignal,
    toastId?: string
): Promise<AxiosResponse<TaxDocumentItemResult>> => {
    return taxGuruAxios.post(
        documentItemsUrls.filter,
        {
            ...filter,
            specificFilters: [
                ...(filter?.specificFilters ?? []),
                {
                    name: "documentId",
                    value: documentId,
                },
            ],
        },
        {
            // @ts-ignore
            toastId,
            signal,
        }
    );
};

export const deleteDocumentItem = (documentItemId: string, toastId?: string): Promise<AxiosResponse<TaxDocumentItemDto>> => {
    return taxGuruAxios.delete(documentItemsUrls.delete(encodeURIComponent(documentItemId)), {
        // @ts-ignore
        toastId,
    });
};

export const createDocumentItem = (item: TaxDocumentItemRequest, toastId?: string): Promise<AxiosResponse<TaxDocumentItemDto>> => {
    return taxGuruAxios.post(documentItemsUrls.create, item, {
        // @ts-ignore
        toastId,
    });
};

export const splitDocumentItemByBase = (payload: DocumentItemSplitByTaxCentreFormDialogProps, toastId?: string): Promise<AxiosResponse<TaxDocumentItemDto>> => {
    return taxGuruAxios.post(documentItemsUrls.splitByBase(encodeURIComponent(payload.originalItem?.id ?? "")), payload, {
        // @ts-ignore
        toastId,
    });
};

export const updateDocumentItem = (
    documentItemId: string,
    item: TaxDocumentItemRequest,
    toastId?: string
): Promise<AxiosResponse<TaxDocumentItemDto>> => {
    return taxGuruAxios.put(documentItemsUrls.update(encodeURIComponent(documentItemId)), item, {
        // @ts-ignore
        toastId,
    });
};

export const getDocumentItem = (
    documentItemId: string,
    toastId?: string,
    signal?: AbortSignal,
    noErrorToast?: boolean
): Promise<TaxDocumentItemDto> => {
    return taxGuruAxios
        .get(documentItemsUrls.get(encodeURIComponent(documentItemId)), {
            // @ts-ignore
            toastId,
            signal,
            noErrorToast,
        })
        .then((data) => data.data);
};
